{
  "common.yes": "Yes",
  "common.no": "No",
  "common.related": "RELATED",
  "common.relatedNav": "Related pages",
  "common.breadcrumb": "Breadcrumb",
  "common.home": "HOME",
  "cite.title": "Source: {{label}} (checked {{date}})",

  "meta.home.title": "GST InvoiceNow Requirement Singapore (IRAS): Guide & Checklist",
  "meta.home.description": "Plain-English guide to Singapore’s GST InvoiceNow Requirement: a five-step checklist, key dates, free software and grants, each sourced from IRAS and IMDA.",
  "meta.home.crumb": "Home",
  "meta.home.llms": "What InvoiceNow is, its benefits, a five-step checklist, upcoming IRAS events and where to ask questions.",
  "meta.setup.title": "How to Set Up GST InvoiceNow in Singapore: 5 Steps",
  "meta.setup.description": "Step-by-step InvoiceNow setup for GST-registered businesses in Singapore: check your date, choose InvoiceNow-Ready software, get a Peppol ID, switch on submission to IRAS and test it.",
  "meta.setup.crumb": "Setup guide",
  "meta.setup.nav": "Setup",
  "meta.setup.llms": "The five steps to get ready for the GST InvoiceNow Requirement, each with its official source, a Peppol ID search, and where you sign in to use InvoiceNow.",
  "meta.when.title": "When Does GST InvoiceNow Apply? Phases and Date Calculator",
  "meta.when.description": "GST InvoiceNow phases from 1 Nov 2025 to 1 Apr 2031, plus a date calculator that follows the IRAS FAQ for supplies, new registrants and GST groups.",
  "meta.when.crumb": "When it applies",
  "meta.when.nav": "When",
  "meta.when.llms": "Implementation timeline and the date calculator rules (IRAS FAQ Q1.5 to Q1.12, Q7.2).",
  "meta.free-software.title": "GST InvoiceNow Software: Free Packages, Providers, Grants",
  "meta.free-software.description": "Free-of-charge InvoiceNow packages, whether Xero, AutoCount, ABSS, SAP Business One, QuickBooks and other software are on IMDA’s InvoiceNow-Ready list, and how to find a provider.",
  "meta.free-software.crumb": "Software and grants",
  "meta.free-software.nav": "Software and grants",
  "meta.free-software.llms": "Free-of-charge package, which popular accounting software is on IMDA’s InvoiceNow-Ready list, provider lists, and a helper to choose between a free package, an IRSP and an Access Point.",
  "meta.grants.title": "InvoiceNow Grants: S$1,000 and S$5,000 Transition Grant, Queen Bee",
  "meta.grants.description": "IMDA's GST InvoiceNow Transition Grants (S$1,000 and S$5,000) and the S$25,000 Queen Bee Grant: who qualifies, conditions, deadlines and claim forms, each sourced from IMDA.",
  "meta.grants.crumb": "Grants",
  "meta.grants.nav": "Grants",
  "meta.grants.llms": "The S$1,000 and S$5,000 GST InvoiceNow Transition Grants, the S$25,000 Queen Bee Grant and the Productivity Solutions Grant: eligibility, conditions, periods and claim forms.",
  "meta.how-it-works.title": "How GST InvoiceNow Works: Submission Types and Peppol ID",
  "meta.how-it-works.description": "How an invoice travels on InvoiceNow and reaches IRAS (Types 1A, 1B, 2 and 3), what a Peppol ID, IRSP and Access Point are, and a Peppol ID check.",
  "meta.how-it-works.crumb": "How it works",
  "meta.how-it-works.nav": "How it works",
  "meta.how-it-works.llms": "Animated submission types, what you need (Peppol ID, IRSP or Access Point) and a Peppol ID check.",
  "meta.pos-and-retail.title": "GST InvoiceNow for POS and Retail: Sales Data and Receipts",
  "meta.pos-and-retail.description": "What the GST InvoiceNow Requirement means if you sell through a POS or cash register: receipts, aggregated sales, customers not on InvoiceNow, deadlines.",
  "meta.pos-and-retail.crumb": "POS and retail",
  "meta.pos-and-retail.nav": "POS & retail",
  "meta.pos-and-retail.llms": "POS and aggregated sales (IRAS FAQ Q3.4, Q3.12), customers not on InvoiceNow, deadlines and acknowledgement IDs.",
  "meta.faq.title": "GST InvoiceNow FAQ: Answers Sourced from IRAS",
  "meta.faq.description": "Short answers on Singapore’s GST InvoiceNow Requirement, each sentence linked to the IRAS FAQ question or e-Tax Guide paragraph it comes from.",
  "meta.faq.crumb": "FAQ",
  "meta.faq.nav": "FAQ",
  "meta.faq.llms": "Every FAQ answer, with a source for each sentence.",
  "meta.links.title": "GST InvoiceNow Links: IRAS, IMDA, Grants, Provider Lists",
  "meta.links.description": "Every official GST InvoiceNow link in one place: IRAS e-Tax Guide and FAQ, IMDA grants, and the solution provider and Access Point lists, each explained.",
  "meta.links.crumb": "Useful links",
  "meta.links.nav": "Links",
  "meta.links.llms": "Every official IRAS and IMDA link, each explained.",
  "meta.about.title": "About InvoiceNow Hub: Independent, Unofficial, Sourced",
  "meta.about.description": "Who runs InvoiceNow Hub, why it exists, how every fact is checked against IRAS and IMDA sources, and what data the site stores.",
  "meta.about.crumb": "About",
  "meta.about.llms": "Who runs the site, how facts are checked, and privacy.",
  "meta.changelog.title": "InvoiceNow Hub Changelog: Content Changes by Date",
  "meta.changelog.description": "A dated public record of every content change on InvoiceNow Hub, including corrections made after checking IRAS and IMDA sources.",
  "meta.changelog.crumb": "Changelog",
  "meta.changelog.llms": "Dated list of content changes.",
  "meta.notfound.title": "Page not found · InvoiceNow Hub",
  "meta.notfound.description": "There is no page at this address.",

  "banner.aria": "About this site",
  "banner.text": "<b>Independent guide.</b> Not affiliated with IRAS or IMDA. For your own case, ask <iras>IRAS</iras> or <imda>IMDA</imda> directly.",
  "banner.about": "About this site",
  "i18n.unofficial": "<b>Unofficial translation.</b> The English version prevails.",
  "i18n.englishLink": "Read this page in English",
  "i18n.draft": "Draft translation, not yet reviewed by a native speaker. Do not rely on it.",
  "i18n.switcher": "Language",
  "i18n.current": "Current language: {{language}}",

  "nav.main": "Main",
  "nav.footer": "Footer",
  "nav.whatToDo": "What should I do?",
  "nav.whatToDoShort": "What to do",
  "nav.question": "I have a question",
  "nav.openMenu": "Open menu",
  "nav.closeMenu": "Close menu",
  "nav.overview": "Overview",
  "nav.privacy": "Privacy",

  "footer.disclaimer": "Independent information hub, not affiliated with IRAS or IMDA. Every fact links to the IRAS or IMDA document it comes from; last checked against them on {{date}}. Always confirm with the official source, and take questions about your own case to <iras>IRAS</iras> or <imda>IMDA</imda>.",
  "footer.made": "MADE WITH <heart>♥</heart> IN SINGAPORE",
  "footer.love": "love",
  "footer.updated": "LAST UPDATED {{date}}",

  "welcome.loading": "Loading InvoiceNow Hub",
  "welcome.top": "INDEPENDENT GUIDE",
  "welcome.place": "SINGAPORE · {{year}}",
  "welcome.tagline": "GST INVOICENOW REQUIREMENT, IN ONE PLACE",

  "hero.srTitle": "InvoiceNow: the GST InvoiceNow Requirement for Singapore businesses, in one place",
  "hero.fig1": "FIG. 01 — SINGAPORE BUSINESSES SENDING E-INVOICES STRAIGHT TO EACH OTHER",
  "hero.fig2": "FIG. 02 — E-INVOICING CONNECTS SINGAPORE TO THE REGION AND THE WORLD",
  "hero.einvoice": "E-INVOICE",
  "hero.inOnePlace": "in one place",
  "hero.lead": "What the GST InvoiceNow Requirement is, when it applies to your business, and what to do next.",
  "hero.lastVerified": "Last verified against official sources: {{date}}",
  "hero.cta": "START THE CHECKLIST",
  "hero.mapAria": "Animated map: businesses across Singapore, each shown with an icon for its kind of business, send e-invoices to each other. The view then expands to a globe showing Singapore connected to Asia-Pacific.",

  "intro.eyebrow": "01 — INVOICENOW 101",
  "intro.title": "InvoiceNow<br/><accent>101</accent>",
  "intro.lead": "InvoiceNow is Singapore’s nationwide e-invoicing network. Start here: what it is, what to do first, and where to find the details.",
  "intro.today": "TODAY",
  "intro.with": "WITH INVOICENOW",
  "intro.node.supplier": "SUPPLIER",
  "intro.node.pdf": "PDF",
  "intro.node.email": "EMAIL",
  "intro.node.retype": "RETYPE",
  "intro.node.customer": "CUSTOMER",
  "intro.node.network": "NETWORK",
  "intro.node.iras": "IRAS",
  "intro.todayBody": "An invoice is a PDF or paper copy. The customer reads it and types the numbers into their own system again.",
  "intro.withBody": "The invoice goes straight from the supplier’s software to the customer’s as structured data: no PDF, no retyping. For GST-registered businesses, a copy of the invoice data also goes to IRAS.",

  "explore.eyebrow": "FIND THE DETAILS",
  "explore.when.text": "The phases from 2025 to 2031, and a date calculator that follows the IRAS FAQ.",
  "explore.free-software.text": "IMDA’s free-of-charge packages, the InvoiceNow grants, and how to find a provider.",
  "explore.how-it-works.text": "How an invoice and its data travel, what a Peppol ID and Access Point are, and your next steps.",
  "explore.pos-and-retail.text": "Receipts, aggregated sales and customers who are not on InvoiceNow.",
  "explore.faq.text": "Short answers, each sentence linked to the IRAS FAQ question it comes from.",
  "explore.links.text": "Every official IRAS and IMDA link, each explained.",

  "checklist.start": "START HERE",
  "checklist.title": "What to do now",
  "checklist.progress": "{{done}} OF {{total}} DONE",
  "checklist.reset": "RESET CHECKLIST",
  "checklist.guide": "Full step-by-step guide",
  "setup.step": "STEP {{n}} OF {{total}}",
  "setup.loginTitle": "Is there an InvoiceNow login?",
  "setup.loginLead": "You use InvoiceNow through your InvoiceNow-Ready Solution, so you sign in to your provider’s software, and that is where your submissions show up.",
  "setup.trackerNote": "Prefer to tick off steps as you go?",
  "setup.trackerLink": "Use the checklist on the homepage",
  "checklist.nextStep": "YOUR NEXT STEP · {{n}} OF {{total}}",
  "checklist.allDone": "ALL STEPS DONE 🎉",
  "checklist.iDidThis": "I have done this",
  "checklist.pill.back": "Back to checklist",
  "checklist.pill.done": "{{done}}/{{total}} DONE",
  "checklist.pill.region": "Checklist shortcut",
  "checklist.pill.hide": "Hide checklist shortcut",
  "checklist.pill.show": "Show checklist shortcut",
  "checklist.pill.showAria": "Show checklist shortcut, {{done}} of {{total}} done",
  "checklist.step.0.t": "Check your date",
  "checklist.step.0.d": "Find out which phase you are in.",
  "checklist.step.0.title": "Find out your date",
  "checklist.step.0.body": "Use the calculator to see which phase you are in. IRAS should also have notified you through MyTaxMail, so go by that letter.",
  "checklist.step.0.a.0": "Open the date calculator",
  "checklist.step.0.a.1": "See the full timeline",
  "checklist.step.1.t": "Check your software",
  "checklist.step.1.d": "Is it on IMDA’s InvoiceNow-Ready list? No software yet? Pick one.",
  "checklist.step.1.title": "Check your software is InvoiceNow-Ready",
  "checklist.step.1.body": "Look for your software on IMDA’s InvoiceNow-Ready Solution Provider list. If you run your own ERP or in-house system, you need an IMDA-accredited Access Point Provider instead. No software yet? Free-of-charge packages are listed by IMDA.",
  "checklist.step.1.a.0": "IRSP list",
  "checklist.step.1.a.1": "Access Point list",
  "checklist.step.1.a.2": "I don’t have InvoiceNow-Ready software",
  "checklist.step.1.a.3": "Using a POS or retail system?",
  "checklist.step.1.a.4": "Help me choose",
  "checklist.step.2.t": "Get your Peppol ID",
  "checklist.step.2.d": "Talk to your IRSP or Access Point provider.",
  "checklist.step.2.title": "Get your Peppol ID",
  "checklist.step.2.body": "Ask your IRSP or Access Point provider to register your business in the SG Peppol Directory with your UEN. Search below to see if you already have one.",
  "checklist.step.2.a.0": "Request a callback from FOC providers",
  "checklist.step.2.a.1": "What you need to get started",
  "checklist.step.3.t": "Switch on GST InvoiceNow submission",
  "checklist.step.3.d": "Talk to your IRSP or Access Point provider.",
  "checklist.step.3.title": "Switch on GST InvoiceNow submission",
  "checklist.step.3.body": "Activate your GST InvoiceNow submission feature to start submitting invoice data to IRAS. Your IRSP or Access Point provider can help.",
  "checklist.step.3.a.0": "How submission to IRAS works",
  "checklist.step.3.a.1": "Read the FAQ",
  "checklist.step.4.t": "Ensure submission works",
  "checklist.step.4.d": "Send a test invoice and confirm IRAS acknowledges it.",
  "checklist.step.4.title": "Make sure submission works",
  "checklist.step.4.body": "Test before your date and check your solution shows an IRAS acknowledgement ID for each successful transmission. For in-house systems, IRAS says to allow {{from}} to {{to}} months for system connection.",
  "checklist.step.4.a.0": "Read the e-Tax Guide",
  "checklist.step.4.a.1": "Join an IRAS webinar",
  "checklist.step.4.a.2": "Every useful link",
  "checklist.done.title": "You are InvoiceNow-ready",
  "checklist.done.body": "Keep sending invoice data through your solution and keep your records for at least 5 years. Check the grants you may be able to claim, and tell your trading partners they can send you e-invoices.",
  "checklist.done.a.0": "Grants available",
  "checklist.done.a.1": "Upcoming events",
  "checklist.done.a.2": "I have a question",

  "events.eyebrow": "02 — UPCOMING EVENTS",
  "events.title": "Learn it <accent>live</accent>",
  "events.signup": "Sign up",
  "events.details": "Details",
  "events.none": "No events are open for sign-up right now. <lnk>Check IRAS’s events page</lnk>",
  "events.source": "Listed from <lnk>IRAS’s events page</lnk>. Registration opens and closes on IRAS’s side, so check the page for the latest.",
  "events.asOf": "Event list as of {{date}}.",

  "question.eyebrow": "03 — I HAVE A QUESTION",
  "question.title": "Ask the <accent>right people</accent>",
  "question.lead": "This site is independent and cannot advise on your situation. For anything about your own case, use the official IRAS and IMDA contact forms below.",
  "question.allLinks": "See all useful links",
  "question.faq": "Common FAQs",

  "head.setup.eyebrow": "SETUP GUIDE",
  "head.setup.title": "Set up InvoiceNow <accent>in five steps</accent>",
  "head.setup.intro": "To get ready for the GST InvoiceNow Requirement: find your implementation date, check your software is InvoiceNow-Ready (or pick a free package), get a Peppol ID through your provider, switch on GST InvoiceNow submission, and confirm IRAS acknowledges your invoice data.",
  "head.when.eyebrow": "WHEN IT APPLIES",
  "head.when.title": "When GST InvoiceNow <accent>applies to you</accent>",
  "head.when.intro": "The GST InvoiceNow Requirement is phased in from 2025 to 2031. Find your phase on the timeline, or answer a few questions in the calculator. Go by IRAS’s MyTaxMail letter if you have one.",
  "head.free-software.eyebrow": "SOFTWARE AND GRANTS",
  "head.free-software.title": "InvoiceNow software <accent>and grants</accent>",
  "head.free-software.intro": "IMDA lists free-of-charge InvoiceNow packages for GST-registered businesses, and runs grants towards subscriptions and connecting your own system.",
  "head.grants.eyebrow": "GRANTS",
  "head.grants.title": "InvoiceNow <accent>grants</accent>",
  "head.grants.intro": "IMDA pays cash grants towards getting your business onto GST InvoiceNow: a Transition Grant sized to your business, and a larger grant for connecting your own ERP. Check which one fits before you subscribe or start a project: the conditions cover when you sign up and what you used before.",
  "head.how-it-works.eyebrow": "HOW IT WORKS",
  "head.how-it-works.title": "How GST InvoiceNow <accent>works</accent>",
  "head.how-it-works.intro": "How an invoice and its data travel on InvoiceNow, what you need to take part, and a short checker that points you to your next step.",
  "head.pos-and-retail.eyebrow": "POS AND RETAIL",
  "head.pos-and-retail.title": "GST InvoiceNow for <accent>POS and retail</accent>",
  "head.pos-and-retail.intro": "If you sell to the public through a point-of-sale system or cash register, these are the parts of the requirement that matter most.",
  "head.faq.eyebrow": "FAQ",
  "head.faq.title": "GST InvoiceNow <accent>FAQ</accent>",
  "head.faq.intro": "Plain-English answers to common questions about the GST InvoiceNow Requirement, sourced sentence by sentence.",

  "timeline.eyebrow": "TIMELINE",
  "timeline.title": "Who joins, <accent>and when</accent>",
  "timeline.lead": "Phased from 2025 to 2031. If you are already GST-registered, your phase depends on your total annual supplies.",
  "timeline.inEffect": "● IN EFFECT",
  "timeline.next": "○ NEXT · {{until}}",
  "timeline.future": "○ {{until}}",
  "timeline.cta": "Check your implementation date",
  "timeline.source": "Source: <lnk>{{label}}</lnk>. Thresholds are total annual supplies in periods ending in 2025.",
  "until.inEffect": "IN EFFECT",
  "until.underMonth": "UNDER A MONTH AWAY",
  "until.oneMonth": "1 MONTH AWAY",
  "until.months": "{{count}} MONTHS AWAY",

  "calc.eyebrow": "CALCULATOR",
  "calc.title": "GST InvoiceNow Implementation Date Calculator",
  "calc.mytaxmailLead": "Go by your IRAS MyTaxMail letter.",
  "calc.indicative": "This calculator is only indicative. IRAS also publishes its own <lnk>calculator spreadsheet</lnk>.",
  "calc.q1": "1. Which describes your business?",
  "calc.kind.existing": "Already GST-registered",
  "calc.kind.voluntary": "Registering voluntarily",
  "calc.kind.compulsory": "Registering compulsorily",
  "calc.kind.group": "Part of a GST group",
  "calc.kind.excluded": "Overseas entity, or registered only due to reverse charge",
  "calc.kind.notRegistered": "Not GST-registered",
  "calc.q1hint": "Applied for compulsory registration but approved on a voluntary basis? Choose this option (IRAS FAQ Q1.6).",
  "calc.q2": "2. When did you (or will you) apply for GST registration?",
  "calc.q2hint": "The application date counts, not the approval date (IRAS FAQ Q1.7).",
  "calc.q3": "3. Was the company incorporated within 6 months before the application?",
  "calc.q4": "4. Was it redomiciled to Singapore (moved its registration here)?",
  "calc.qReturns": "{{n}}. Do you have GST returns for accounting periods ending in 2025?",
  "calc.returnsYes": "Yes, including nil returns",
  "calc.qEnds": "Which months do your accounting periods end in?",
  "calc.ends.mar-jun-sep-dec": "Mar, Jun, Sep, Dec",
  "calc.ends.jan-apr-jul-oct": "Jan, Apr, Jul, Oct",
  "calc.ends.feb-may-aug-nov": "Feb, May, Aug, Nov",
  "calc.ends.monthly": "Every month",
  "calc.window.mar-jun-sep-dec": "January 2025 to December 2025",
  "calc.window.jan-apr-jul-oct": "November 2024 to October 2025",
  "calc.window.feb-may-aug-nov": "December 2024 to November 2025",
  "calc.window.monthly": "January 2025 to December 2025",
  "calc.suppliesFrom": "Your supplies from {{window}}",
  "calc.addUp": "Add up all returns for periods ending in 2025 (Box 4 is the total). Nil returns count as S$0.",
  "calc.sr": "Standard-rated (S$)",
  "calc.zr": "Zero-rated (S$)",
  "calc.ex": "Exempt (S$)",
  "calc.qFull": "Do those returns cover a full 12 months?",
  "calc.fullNo": "No, part of the year",
  "calc.qDays": "How many days do they cover?",
  "calc.daysPlaceholder": "e.g. 61",
  "calc.empty": "Answer the questions to see your phase. Nothing you enter leaves your browser.",
  "calc.kicker.phase": "YOUR PHASE · {{until}}",
  "calc.kicker.from-registration": "APPLIES FROM REGISTRATION",
  "calc.kicker.iras-will-notify": "IRAS WILL NOTIFY YOU",
  "calc.kicker.follow-group": "FOLLOW YOUR GST GROUP",
  "calc.kicker.not-required": "NOT REQUIRED",
  "calc.date.from-registration": "From registration",
  "calc.date.iras-will-notify": "IRAS will tell you",
  "calc.date.follow-group": "Your group’s date",
  "calc.date.not-required": "Not required",
  "calc.total": "TOTAL ANNUAL SUPPLIES",
  "calc.equiv": "(365-DAY EQUIVALENT)",
  "calc.nextSteps": "Check my next steps",
  "calc.ask": "Ask IRAS about my case",
  "calc.disclaimer": "Indicative only. The date in IRAS’s MyTaxMail notification is the one that counts. Part of a franchise or similar group sharing an ERP that needs more time? IRAS considers extension requests case by case (FAQ Q1.14).",

  "faq.count": "{{count}} QUESTIONS, SOURCED",
  "faq.lead": "Short answers. Each sentence links to the official document that says it, mostly IRAS’s <lnk>FAQ for businesses (23 Sep 2026)</lnk> and e-Tax Guide.",
  "faq.own": "For questions about your own business, use the <iras>IRAS queries form</iras> or <imda>IMDA contact form</imda>.",

  "grants.imda": "IMDA InvoiceNow grants",
  "grants.infographic": "Infographic",
  "grants.footnote": "Grant terms from the <grants>{{grantsLabel}}</grants>. Check eligibility and the terms and conditions with IMDA before you subscribe or start a project.",
  "grants.answerTitle": "Which InvoiceNow grants are there?",
  "grants.faqLink": "IMDA grants FAQs",
  "grants.faqHeading": "RELATED QUESTIONS",
  "software.heading": "FREE PACKAGE",
  "software.grantsTitle": "InvoiceNow grants",
  "software.grantsBody": "IMDA Transition Grants and the Queen Bee Grant towards a paid solution or connecting your own ERP.",
  "software.grantsLink": "See the grants",
  "software.checkTitle": "Is my accounting software InvoiceNow-Ready?",
  "software.checkLead": "Here is how popular packages appear on it. The list changes often, so confirm with the latest version and with your provider.",
  "software.colSoftware": "Software",
  "software.colStatus": "On IMDA’s list?",
  "software.listed.provider": "Yes, listed for <en>{{provider}}</en>",
  "software.listed.partners": "Yes, through several listed implementation partners",
  "software.listed.no": "Not on the list",
  "software.notListed": "Not on the list?",
  "software.footnote": "Free package from the <foc>{{focLabel}}</foc>. Check the terms and conditions with IMDA and the provider before you subscribe.",
  "vendor.title": "Finding an InvoiceNow-Ready Solution Provider or Access Point Provider",
  "vendor.irsp": "InvoiceNow-Ready Solution Provider list",
  "vendor.ap": "Access Point list",
  "vendor.foc": "Free-of-charge (FOC) package list",
  "vendor.callback": "Request a callback from FOC providers",
  "vendor.allow": "ALLOW",
  "vendor.months": "<from/>–<to/> months",
  "vendor.note": "for connecting an in-house enterprise system to IRAS, IRAS says",

  "how.eyebrow": "HOW AN INVOICE TRAVELS",
  "how.title": "How an invoice<br/><accent>travels</accent>",
  "how.lead": "InvoiceNow sends invoices between businesses through Access Points, and reports the invoice data to IRAS. How it travels depends on whether you are sending or receiving, and whether the other business is on InvoiceNow too.",
  "need.eyebrow": "WHAT YOU NEED",
  "need.peppolTitle": "A Peppol ID",
  "need.peppolBody": "Your business’s unique address on the InvoiceNow network. Ask your IRSP or Access Point provider to register your business in the SG Peppol Directory with your UEN.",
  "need.irspTitle": "An InvoiceNow-Ready Solution Provider (IRSP) or Access Point (AP)",
  "need.irspBody": "An IRSP offers accounting or finance software already connected to the network through an accredited Access Point. If you run your own in-house system, you connect it through an IMDA-accredited Access Point Provider.",
  "need.find": "Find an IRSP or Access Point",
  "peppol.label": "SEARCH BY COMPANY NAME OR UEN",
  "peppol.placeholder": "Company name or UEN, e.g. 201538812W",
  "peppol.aria": "Company name or UEN",
  "peppol.check": "Check Peppol ID",
  "peppol.searching": "Searching…",
  "peppol.invalid": "Type at least 2 letters of your company name, or your UEN.",
  "peppol.unreachable": "Could not reach the Peppol Directory just now. Try again shortly.",
  "peppol.found": "<b>Found:</b> {{name}} <id>{{peppolId}}</id>. Your next job is to confirm it is linked to the provider you plan to use.",
  "peppol.registered": "Registered",
  "peppol.notFound": "Not found in the Peppol Directory. That is normal if you have not onboarded yet. Your IRSP or Access Point provider registers it for you. <lnk>Find a provider</lnk>",
  "peppol.notFoundName": "No match for that name. Try your full registered name or your UEN. Not registered yet? Your IRSP or Access Point provider registers it for you. <lnk>Find a provider</lnk>",
  "peppol.matches": "Matches in the Peppol Directory: {{total}}. If your business is listed, it already has a Peppol ID. Your next job is to confirm it is linked to the provider you plan to use.",
  "peppol.more": "Showing {{shown}} of {{total}}. Type more of the name, or your UEN, to narrow it down.",

  "flow.iAm": "I AM THE…",
  "flow.supplier": "Supplier, sending invoices",
  "flow.customer": "Customer, receiving invoices",
  "flow.who": "WHO IS ON INVOICENOW?",
  "flow.both": "Both of us",
  "flow.me": "Only me",
  "flow.lane.iras": "IRAS",
  "flow.lane.network": "INVOICENOW NETWORK",
  "flow.lane.businesses": "YOUR BUSINESSES",
  "flow.offline": "PDF · EMAIL · PAPER",
  "flow.node.supplier": "Supplier",
  "flow.node.customer": "Customer",
  "flow.node.iras": "IRAS",
  "flow.node.yours": "Your solution",
  "flow.node.theirs": "Their solution",
  "flow.sub.notOn": "NOT ON INVOICENOW",
  "flow.sub.notNetwork": "NOT ON NETWORK",
  "flow.sub.tax": "TAX AUTHORITY",
  "flow.sub.ap": "ACCESS POINT",
  "flow.you": "YOU",
  "flow.play": "Play animation",
  "flow.pause": "Pause animation",
  "flow.stepAria": "Step {{n}}: {{title}}",
  "flow.legend.invoice": "INVOICE",
  "flow.legend.data": "COPY TO IRAS",
  "flow.legend.offline": "OFF-NETWORK COPY",
  "flow.tag.parallel": "IN PARALLEL",
  "flow.tag.offNetwork": "OFF NETWORK",
  "flow.toPartner": "INVOICE → YOUR BUSINESS PARTNER",
  "flow.toIras": "INVOICE DATA → IRAS",
  "flow.s.supplier.both.headline": "You send, and your customer is on InvoiceNow too",
  "flow.s.supplier.both.toBusiness": "Over the InvoiceNow network: your Access Point forwards the Peppol invoice to your customer’s Access Point as structured data.",
  "flow.s.supplier.both.toIras": "Type 1A submission: once the invoice is sent to your customer’s Access Point, a copy of the Peppol invoice goes to IRAS automatically. Your customer then files their own copy (Type 1B).",
  "flow.s.supplier.both.0.title": "Issue",
  "flow.s.supplier.both.0.text": "You issue a Peppol invoice in your InvoiceNow-Ready Solution and send it to your Access Point. Solutions with GST validation checks alert you if GST is wrongly charged.",
  "flow.s.supplier.both.1.title": "Send and copy to IRAS",
  "flow.s.supplier.both.1.text": "Your Access Point forwards the invoice to your customer’s Access Point. Once it is sent, a copy of the Peppol invoice goes to IRAS automatically.",
  "flow.s.supplier.both.2.title": "Deliver",
  "flow.s.supplier.both.2.text": "Your customer’s Access Point forwards the invoice to your customer.",
  "flow.s.supplier.both.3.title": "Customer files too",
  "flow.s.supplier.both.3.text": "Your customer accepts the invoice in their solution and records their GST purchase details. Their Access Point sends IRAS a Solution-extracted copy of the purchase.",
  "flow.s.supplier.me.headline": "You send, but your customer is not on InvoiceNow",
  "flow.s.supplier.me.toBusiness": "Outside the network: you give your customer a paper or PDF invoice, as you do today.",
  "flow.s.supplier.me.toIras": "Type 2 submission: your solution extracts the invoice and your Access Point sends it to IRAS. This also applies when supplies are aggregated, such as POS sales or simplified tax invoices.",
  "flow.s.supplier.me.0.title": "Issue and record",
  "flow.s.supplier.me.0.text": "You give your customer a paper or PDF invoice and record the sale in your InvoiceNow-Ready Solution. It does not travel on the network.",
  "flow.s.supplier.me.1.title": "Extract and report",
  "flow.s.supplier.me.1.text": "Your solution submits a Solution-extracted invoice to your Access Point, which transmits it to IRAS.",
  "flow.s.customer.both.headline": "You receive, and your supplier is on InvoiceNow too",
  "flow.s.customer.both.toBusiness": "Over the InvoiceNow network: your supplier’s Access Point forwards the Peppol invoice to yours as structured data.",
  "flow.s.customer.both.toIras": "Type 1B submission: after you accept the invoice, a Solution-extracted copy of your purchase goes to IRAS through your Access Point. Your supplier’s Peppol copy (Type 1A) is sent separately.",
  "flow.s.customer.both.0.title": "Issue",
  "flow.s.customer.both.0.text": "Your supplier issues a Peppol invoice in their InvoiceNow-Ready Solution.",
  "flow.s.customer.both.1.title": "Send",
  "flow.s.customer.both.1.text": "Their Access Point forwards it to yours. Once sent, a copy of the Peppol invoice goes to IRAS from their side.",
  "flow.s.customer.both.2.title": "Receive",
  "flow.s.customer.both.2.text": "Your Access Point forwards the invoice to you as data, with no re-keying.",
  "flow.s.customer.both.3.title": "Accept and report",
  "flow.s.customer.both.3.text": "You validate and accept it in your solution, choosing the GST category, purchase amount and input tax to claim. A Solution-extracted copy goes to IRAS through your Access Point.",
  "flow.s.customer.me.headline": "You receive, but your supplier is not on InvoiceNow",
  "flow.s.customer.me.toBusiness": "Outside the network: the invoice reaches you as a PDF or on paper, as it does today.",
  "flow.s.customer.me.toIras": "Type 3 submission: your solution extracts the purchase and your Access Point sends it to IRAS. This also applies to aggregated purchases such as petty cash.",
  "flow.s.customer.me.0.title": "Receive",
  "flow.s.customer.me.0.text": "Your supplier sends you a paper or PDF invoice. It does not travel on the network.",
  "flow.s.customer.me.1.title": "Record",
  "flow.s.customer.me.1.text": "You record the purchase in your InvoiceNow-Ready Solution. Solutions with GST validation checks alert you if GST is wrongly charged.",
  "flow.s.customer.me.2.title": "Extract and report",
  "flow.s.customer.me.2.text": "Your solution sends a Solution-extracted invoice to your Access Point, which transmits it to IRAS.",

  "next.eyebrow": "HELP ME CHOOSE",
  "next.title": "Which option fits me?",
  "next.q3": "1. How many invoices do you issue and receive?",
  "next.vol.low": "Low",
  "next.vol.lowSub": "A handful a month",
  "next.vol.medium": "Medium",
  "next.vol.mediumSub": "Dozens a month",
  "next.vol.high": "High",
  "next.vol.highSub": "Hundreds or more",
  "next.q4": "2. What do you use for invoicing today?",
  "next.tool.manual": "Manual",
  "next.tool.manualSub": "Word, Excel, PDFs",
  "next.tool.software": "Accounting software",
  "next.tool.softwareSub": "Off-the-shelf package",
  "next.tool.custom": "ERP or in-house system",
  "next.tool.customSub": "Custom or integrated",
  "next.empty": "Answer two questions and we’ll suggest the type of solution to look at first.",
  "next.disclaimer": "General guidance only. Check eligibility, pricing and availability with IMDA, IRAS and the provider before you commit.",
  "next.route.kicker": "RECOMMENDED ROUTE",
  "next.rec.FOC.name": "A free-of-charge (FOC) solution",
  "next.rec.FOC.what": "IMDA lists free-of-charge InvoiceNow packages for GST-registered businesses. They may suit businesses that issue only a few invoices and work from spreadsheets, Word or PDFs today.",
  "next.rec.FOC.0": "Pick a package from IMDA’s free-of-charge list. Start and end dates differ by provider, so check the dates for the one you choose.",
  "next.rec.FOC.1": "Sign up, then register your Peppol ID (your UEN-based ID) through the provider.",
  "next.rec.FOC.2": "Send a test invoice and confirm the data reaches IRAS before your start date.",
  "next.rec.IRSP.name": "An InvoiceNow-Ready Solution Provider (IRSP)",
  "next.rec.IRSP.what": "Accounting or invoicing software with a built-in Access Point connection, so invoices and the IRAS data submission happen from the tool you already work in.",
  "next.rec.IRSP.0": "Check IMDA’s list of InvoiceNow-Ready Solution Providers. If your current software is on it, ask the vendor how to switch on InvoiceNow.",
  "next.rec.IRSP.1": "If it is not, shortlist a listed provider that fits your invoice volume and budget.",
  "next.rec.IRSP.2": "Have the provider register your Peppol ID, then test sending before your start date.",
  "next.rec.AP.name": "A Peppol Access Point (AP) provider",
  "next.rec.AP.what": "A provider that connects your own system (ERP or in-house) to the network. Best when invoices are generated by software you control or at high volume.",
  "next.rec.AP.0": "List the systems that generate and receive your invoices, and who maintains the integration.",
  "next.rec.AP.1": "Shortlist providers from IMDA’s Access Point Provider list and confirm they support your system’s export format.",
  "next.rec.AP.2": "Register your Peppol ID through the Access Point, then run end-to-end tests including the IRAS data submission.",
  "next.link.iras": "IRAS requirement page",
  "next.link.foc": "FOC package list",
  "next.link.ap": "Access Point list",
  "next.link.irsp": "IRSP list",

  "links.eyebrow": "USEFUL LINKS",
  "links.title": "Every link, <accent>explained</accent>",

  "about.eyebrow": "ABOUT",
  "about.title": "Independent, <accent>unofficial</accent>, sourced",
  "about.who.title": "Who runs this site",
  "about.who.body": "InvoiceNow Hub is an independent website. It is not run by, endorsed by or affiliated with the Inland Revenue Authority of Singapore (IRAS) or the Infocomm Media Development Authority (IMDA).",
  "about.why.title": "Why it exists",
  "about.why.body": "Official information on the GST InvoiceNow Requirement is spread across several IRAS and IMDA web pages and PDFs. This site puts it in one place, in plain English, and links every statement back to the official document that says it.",
  "about.unofficial.title": "It is unofficial",
  "about.unofficial.body": "Nothing here is legal or tax advice, and it does not replace the implementation date IRAS sends you through MyTaxMail. If anything here differs from IRAS or IMDA, the official source is right.",
  "about.unofficial.channels": "For anything about your own business, use the official channels: <iras>IRAS GST InvoiceNow queries form</iras> or <imda>IMDA InvoiceNow contact form</imda>.",
  "about.translations.title": "Translations",
  "about.translations.body": "Chinese, Malay and Tamil versions are unofficial translations of the English text. The English version prevails. Translations not yet reviewed by a native speaker are marked as drafts at the top of each page; if the English changes, the English is shown until the translation is updated.",
  "about.check.title": "How content is checked",
  "about.check.body": "Every date, threshold, amount, FAQ answer and link is stored in one data file with the URL of the official source, the exact question or paragraph number, and the date it was last checked. Pages, the FAQ data for search engines and the <txt>plain-text version</txt> are all generated from that file, so they cannot drift apart. An automated check confirms every source link still works and flags anything not re-checked in the last 30 days.",
  "about.check.last": "Content was last checked against official sources on <b>{{date}}</b>. These are the only sources the site relies on:",
  "about.check.checked": "checked {{date}}",
  "about.check.changelog": "Every change to the content is listed with its date in the <lnk>changelog</lnk>.",
  "about.privacy.title": "Privacy",
  "about.privacy.lead": "This site does not ask for your name, email or any account. Its own code loads no advertising scripts.",
  "about.privacy.checklist": "<b>Checklist:</b> “What to do now” saves how many steps you have ticked (a single number) in your browser’s local storage, so it is still there next time. It never leaves your device. Use “Reset checklist” or clear this site’s data to remove it.",
  "about.privacy.display": "<b>Display settings:</b> whether you have seen the opening animation and whether you closed the checklist shortcut are kept in session storage, which your browser clears when you close the tab.",
  "about.privacy.language": "<b>Language:</b> if you pick a language with the language switcher, a small cookie remembers your choice so the site does not redirect you. It contains only the language code.",
  "about.privacy.calc": "<b>Date calculator and “Which option fits me?”:</b> run entirely in your browser and store nothing.",
  "about.privacy.peppol": "<b>Peppol ID check:</b> the company name or UEN you type is sent to the public Peppol Directory (directory.peppol.eu) to search for it. Nothing else is sent, and the site’s code does not store it.",
  "about.privacy.fonts": "<b>Fonts:</b> served from this site, not from a third party.",
  "about.privacy.analytics": "<b>Analytics:</b> Cloudflare Web Analytics is currently switched on by our host, Cloudflare. It adds a script from static.cloudflareinsights.com that sends page-view data to Cloudflare. It is not part of this site’s code; this note will be updated if it is switched off.",

  "changelog.eyebrow": "CHANGELOG",
  "changelog.title": "What changed, <accent>and when</accent>",
  "changelog.lead": "Every content change on this site, newest first. Facts are checked against the official IRAS and IMDA sources listed on the <lnk>About page</lnk>.",

  "notfound.title": "Page <accent>not found</accent>",
  "notfound.body": "There is no page at this address. It may have moved when the site was split into topic pages.",
  "notfound.home": "Go to the homepage",
  "notfound.links": "Useful links"
}
